import React from 'react';
import PropTypes from 'prop-types';

const  AcceptTerms = ({isChecked = false, isError = true, onChange = () => {}}) => {
    return (

        <div className="terms-wrp">
            <div className="accept__link-wrap">
                <input id="accept" name="accept" type="checkbox" value="accept" checked={isChecked} onChange={() => {}} />
                <label id="accept-label" className="form_nav__label" htmlFor="accept" onClick={() => {onChange(!isChecked)}}></label>
                <span>I accept
                    <a className="accept__link" target="_blank" href="/terms-and-conditions"> terms and conditions</a>
                </span><br />
                {isError &&
                    <div className="validation_error" id="error_accept">Please, accept terms and conditions</div>
                }
                <div className="terms__text">We’ll occasionally send you promo and account related emails</div>
            </div>
        </div>

    )
}

AcceptTerms.propTypes = {
    isChecked: PropTypes.bool,
    isError: PropTypes.bool,
    onChange: PropTypes.func,
};

export default AcceptTerms;